{
  "subsDetails": {
    "App Designer enables you to create real-time applications without having to code.": "O App Designer permite que você crie aplicativos em tempo real sem precisar codificar.",
    "Create visual, model-driven data flows that combine Event Stream Processing with ETL and data contextualization.": "Crie fluxos de dados visuais e orientados a modelos que combinam Event Stream Processing com ETL e contextualização de dados.",
    "XMPro AI Designer Product for Jupyter Hub Authentication": "Produto XMPro AI Designer para autenticação do Jupyter Hub"
  },
  "appcenter": {
    "Active": "Ativo",
    "Error": "Erro",
    "Draft": "Rascunho"
  }
}
